import QueryString from './QueryString';
import UrlParams from './UrlParams';

export default class QueryStringFactory
{
    static make(url)
    {
        return new QueryString(new UrlParams(url));
    }
}



// WEBPACK FOOTER //
// ./app/QueryStringFactory.js